import * as React from 'react'
import { ArrowLeftIcon, IconButton } from '@buffer-mono/popcorn'

import { useBackToOmni } from '../../utils/useBackToOmni'
import { BackToOmniConfirmationModal } from './BackToOmniConfirmationModal'

export const BackToOmniButton = (): React.ReactElement | null => {
  const [open, setOpen] = React.useState(false)
  const { backToOmni, canGoBackToOmni } = useBackToOmni()
  if (!canGoBackToOmni) return null

  return (
    <>
      <IconButton
        label="Back"
        variant="tertiary"
        tooltip="Back to previous step"
        onClick={(): void => setOpen(true)}
      >
        <ArrowLeftIcon />
      </IconButton>
      <BackToOmniConfirmationModal
        open={open}
        setOpen={setOpen}
        onConfirm={backToOmni}
      />
    </>
  )
}
